import { setPoc } from "./pocMapper";
import { setBuildingData } from "./buildingMapper";
import { isValidValue } from "utils";

// 🆕 lightweight principal mapper to avoid recursion
export const mapPrincipal = (poc = {}) => ({
  id: poc.id || null,
  first_name: poc.first_name || null,
  last_name: poc.last_name || null,
  email: poc.email || null,
  role: poc.title || null,
  type: poc.type || null,
});
export const pocSetup = (poc = {}) => ({
  role: poc.role || null,
  first_name: poc.first_name || null,
  prefix: poc.prefix || null,
  type: poc.type || null,
  last_name: poc.last_name || null,
  email: poc.email || null,
  countryCode: poc.countryCode || null,
  phone_number: poc.phone_number || null,
});

export const setCampusData = (el = {}) => {
  let pocs = isValidValue(el.pocs) ? el.pocs.map(setPoc) : [];

  let buildings = isValidValue(el.buildings)
    ? el.buildings.map((el1) =>
        setBuildingData({
          ...el1,
          district_id: el1.district_id,
          campus_id: el1.ID,
        }),
      )
    : [];

  let principal = null;
  const temp = pocs.filter((e) => e.type === "principal");
  if (temp.length) {
    principal = mapPrincipal(temp[0]); // 🔄 no recursive setUserData
  }

  return {
    createdAt: el.CreatedAt || null,
    updatedAt: el.UpdatedAt || null,
    deletedAt: el.DeletedAt || null,
    id: el.ID || null,
    district_id: el.district_id || null,
    num_students: el.num_students || 0,
    num_staff: el.num_staff || 0,
    campus_number: el.campus_number || 0,
    name: el.name || null,
    address: el.address || null,
    city: el.city || null,
    is_incident_in_progress: el.is_incident_in_progress || false,
    building_count: el.building_count || buildings.length,
    state: el.state || null,
    zip_code: el.zip_code || null,
    latitude: el.latitude || null,
    longitude: el.longitude || null,
    geo_latitude: el.geo_latitude || null,
    geo_longitude: el.geo_longitude || null,
    unreal_location_x: el.unreal_location_x || null,
    unreal_location_y: el.unreal_location_y || null,
    invite_code: el.invite_code || null,
    created_by_id: el.created_by_id || null,
    attribute_name_in_directory: el.attribute_name_in_directory || null,
    pocs,
    buildings,
    principal,
  };
};
